import lodash from "lodash";
import { useSelector } from "react-redux";
import { Alert, AlertTitle, Box, Typography } from "@mui/material";
import { getConfig } from "../modules/configuration";

export const Banners = () => {
  const config = useSelector(getConfig);

  return (
    !lodash.isEmpty(config.alert) && (
      <Box className="banners">
        <Alert severity={config.alert.type} variant="outlined">
          <AlertTitle>{config.alert.title}</AlertTitle>
          <Typography>{config.alert.description}</Typography>
        </Alert>
      </Box>
    )
  );
};
